import { useState, useEffect } from "react";

export function useBreakpoint() {
  const [bp, setBp] = useState("desktop");
  useEffect(() => {
    const u = () => setBp(window.innerWidth<600?"mobile":window.innerWidth<1024?"tablet":"desktop");
    u(); window.addEventListener("resize",u);
    return ()=>window.removeEventListener("resize",u);
  },[]);
  return bp;
}
